module.exports = __webpack_public_path__ + "media/images/icons/country_flags/bb-333ab7bf298446feedb31b91a79c714f.svg";